package com.gsb.vyapar.bhagya.interactor.manager

import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.auth.manager.AuthManager
import com.gsb.vyapar.bhagya.presentation.category.manager.CategoriesViewManager
import com.gsb.vyapar.bhagya.presentation.navigation.manager.NavigationManager
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import com.gsb.vyapar.bhagya.presentation.splash.manager.SplashManager

object StateManager {

    private val _uiStateFlow = MutableStateFlow(UiState())
    val uiStateFlow: StateFlow<UiState> get() = _uiStateFlow

    private var scope: CoroutineScope? = null

    fun onTriggerEvent(event: UiEvents) {
        when (event) {
            is UiEvents.Portrait -> updateState(getState().copy(isPortrait = event.isPortrait))
            is UiEvents.SplashEvents -> SplashManager.onTriggerEvent(event.splashUiEvents)
            is UiEvents.NavigationEvents -> NavigationManager.onTriggerEvent(event.navigationEvents)
            is UiEvents.CategoryEvents -> CategoriesViewManager.onTriggerEvent(event.categoryEvents)
            is UiEvents.AuthEvents -> AuthManager.onTriggerEvent(event.authUiEvents)
        }
    }

    fun setViewModelScope(viewModelScope: CoroutineScope) {
        scope = viewModelScope
    }

    fun launchDefault(launch: suspend () -> Unit) {
        scope?.launch(Dispatchers.Default) {
            launch()
        }
    }

    fun launchMain(launch: suspend () -> Unit) {
        scope?.launch(Dispatchers.Main) {
            launch()
        }
    }

    fun updateState(uiState: UiState) {
        _uiStateFlow.value = uiState
    }

    fun getState(): UiState {
        return _uiStateFlow.value
    }

    fun setDeepLink(deepLink: String? = null) {
        updateState(getState().copy(deepLink = deepLink))
    }
}
